define.alias("shared/components/shared/mavely/links/link", "settings/components/shared/mavely/links/link");